// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

    // (() => {
    //     const header = document.querySelector('.site-header');
    //     let lastScroll = window.pageYOffset;
      
    //     window.addEventListener('scroll', () => {
    //       const current = window.pageYOffset;
    //       if (current > lastScroll && current > 50) {
    //         // 下スクロール → ヘッダーを隠す
    //         header.classList.add('is-hidden');
    //       } else {
    //         // 上スクロール → ヘッダーを表示
    //         header.classList.remove('is-hidden');
    //       }
    //       lastScroll = current;
    //     });
    // })();

    // // サブナビゲーションの開閉
    // const links = document.querySelectorAll('span.site-navigation-lists__link');
    // const mq = window.matchMedia('(max-width: 960px)');

    // links.forEach(link => {
    //     link.addEventListener('click', e => {
    //     // 960px 以下のときだけ動作
    //     if (!mq.matches) return;

    //     e.preventDefault();
    //     // 同じ親要素内のナビを取得
    //     const nav = link.parentNode.querySelector('.site-navigation-lists-nav');
    //     if (!nav) return;

    //     link.classList.toggle('is-active');
    //     nav.classList.toggle('is-active');
    //     });
    // });

    // // ハンバーガーメニューの開閉
    // const menuBtn = document.querySelector('.js-mobile-menu');
    // const siteNav = document.querySelector('.site-navigation');
    // const body    = document.body;

    // if (!menuBtn || !siteNav) return;

    // menuBtn.addEventListener('click', e => {
    //     e.preventDefault();

    //     // is-open をトグル
    //     const isOpen = menuBtn.classList.toggle('is-open');
    //     siteNav.classList.toggle('is-open');

    //     // ボディに no-scroll を付与/削除
    //     if (isOpen) {
    //     body.classList.add('is-noscroll');
    //     } else {
    //     body.classList.remove('is-noscroll');
    //     }
    // });


    // 商品一覧用のスライダー
    const shopItemSlide = new Swiper('.js-shop-item-slide', {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // 商品詳細ページのスライダーナビ
    const shopNavSlide = new Swiper(".js-shop-nav-slide", {
      slidesPerView: 7,
      spaceBetween: 4,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        960: {
          slidesPerView: 5,
          spaceBetween: 5,
        }
      }
    });
    
    // 商品詳細ページのスライダー
    const shopSingleSlide = new Swiper(".js-shop-single-slide", {
      loop: true,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      thumbs: {
          swiper: shopNavSlide,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });



// 商品詳細ページのカテゴリでメニュー開閉ぼたん
  const buttons = document.querySelectorAll('.shop-single-nav__button');
  const select  = document.querySelector('.shop-single-select');
  const body = document.body;

  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const wasActive = btn.classList.contains('is-active');

      buttons.forEach((b) => b.classList.remove('is-active'));

      if (!wasActive) {
        btn.classList.add('is-active');
        select.classList.add('is-active');
      } else {
        select.classList.remove('is-active');
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.shop-single-nav__filter') ||
      e.target.closest('.shop-single-select__close')
    ) {
      buttons.forEach((b) => b.classList.remove('is-active'));
      select.classList.remove('is-active');
    }
  });

    // スマホ時ヘッダーメニューの開閉
    const btn = document.querySelector(".js-mobile-menu");
    const header = document.querySelector(".header-inner");
    const filter = document.querySelector(".filter");
    
    const open = () => {
      btn?.classList.add("is-active");
      header?.classList.add("is-active");
      filter?.classList.add("is-show");
      body.classList.add("is-noscroll");
      btn?.setAttribute("aria-expanded", "true");
    };
    
    const close = () => {
      btn?.classList.remove("is-active");
      header?.classList.remove("is-active");
      filter?.classList.remove("is-show");
      body.classList.remove("is-noscroll");
      btn?.setAttribute("aria-expanded", "false");
    };
    
    const toggle = (e) => {
      e.preventDefault();
      if (header?.classList.contains("is-active")) {
        close();
      } else {
        open();
      }
    };
    
    btn?.addEventListener("click", toggle);
    
    filter?.addEventListener("click", (e) => {
      if (e.target === filter) {
        close();
      }
    });
    
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") close();
    });


    // 商品詳細ページのカテゴリでメニュー開閉をマウスでコントロール
    (() => {
      const sheet = document.querySelector('.shop-single-select__list');
      const container = document.querySelector('.shop-single-select');
      if (!sheet || !container) return;
    
      // ハンドルが無ければ自動追加
      let handle = sheet.querySelector('.shop-single-select__handle');
      if (!handle) {
        handle = document.createElement('div');
        handle.className = 'shop-single-select__handle';
        handle.setAttribute('aria-label', 'Drag to close');
        sheet.prepend(handle);
      }
    
      let dragging = false;
      let startY = 0;
      let startOffset = 0;
      let currentY = 0;
      let isClosing = false;
    
      const maxY = () => sheet.offsetHeight;
      const toPercent = (px) => (px / sheet.offsetHeight) * 100;
    
      const setY = (yPx) => {
        const y = Math.max(0, Math.min(yPx, maxY()));
        currentY = y;
        sheet.style.transform = `translateY(${toPercent(y)}%)`;
      };
    
      const open = () => {
        isClosing = false;
        sheet.style.display = 'block';
        requestAnimationFrame(() => {
          sheet.classList.add('is-open');
          sheet.style.transition = 'transform .25s cubic-bezier(.2,0,0,1)';
          setY(0);
        });
      };
    
      const close = () => {
        isClosing = true;
        sheet.style.transition = 'transform .25s cubic-bezier(.2,0,0,1)';
        setY(maxY());
        sheet.classList.remove('is-open');
      };
    
      const mo = new MutationObserver(() => {
        if (container.classList.contains('is-active')) open();
        else close();
      });
      mo.observe(container, { attributes: true, attributeFilter: ['class'] });
    
      sheet.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'transform') return;
    
        const m = sheet.style.transform.match(/translateY\(([-\d.]+)%\)/);
        const currentPercent = m ? parseFloat(m[1]) : 100;
    
        if (isClosing && !sheet.classList.contains('is-open') &&
            (currentPercent >= 99.5 || currentY >= maxY() - 1)) {
          // ★ここで完全にヒットテストから外す（スクロール邪魔しない）
          sheet.style.display = 'none';
    
          // コンテナ/トグルの状態リセット
          container.classList.remove('is-active');
          document.querySelectorAll('.shop-single-nav__button.is-active')
            .forEach((btn) => btn.classList.remove('is-active'));
    
          isClosing = false;
        }
      });
    
      const onDown = (e) => {
        dragging = true;
        startY = e.clientY;
    
        if (!sheet.classList.contains('is-open')) open();
    
        const m = sheet.style.transform.match(/translateY\(([-\d.]+)%\)/);
        const currentPercent = m ? parseFloat(m[1]) : 0;
        startOffset = (currentPercent / 100) * sheet.offsetHeight;
    
        sheet.classList.add('is-dragging');
        sheet.style.transition = 'none';
        handle.setPointerCapture?.(e.pointerId);
        handle.style.cursor = 'grabbing';
      };
    
      const onMove = (e) => {
        if (!dragging) return;
        const dy = e.clientY - startY;
        setY(startOffset + dy);
      };
    
      const onUp = (e) => {
        if (!dragging) return;
        dragging = false;
        handle.releasePointerCapture?.(e.pointerId);
        sheet.classList.remove('is-dragging');
        handle.style.cursor = 'grab';
        sheet.style.transition = 'transform .2s ease-out';
    
        const shouldClose = currentY > sheet.offsetHeight * 0.35;
        if (shouldClose) close(); else open();
      };
    
      handle.addEventListener('pointerdown', onDown);
      handle.addEventListener('pointermove', onMove);
      handle.addEventListener('pointerup', onUp);
      handle.addEventListener('pointercancel', onUp);
    
      if (!container.classList.contains('is-active')) {
        sheet.style.display = 'none';
        setY(maxY());
      }
    })();
});






